<template>
  <div class="row p-2">
    <div class="col-12 col-md-1 d-flex flex-column align-items-center">
      <div
        class="font-weight-semibold text-uppercase"
        :class="{ 'font-color-primary': isActiveLevel }"
      >
        level
      </div>
      <div
        class="font-weight-semibold font-size-36"
        :class="{ 'font-color-primary': isActiveLevel }"
      >
        {{ escalation.level }}
      </div>
    </div>
    <div :class="isShowInfo ? 'col-10 col-md-10' : 'col-10 col-md-9'">
      <div class="row">
        <div class="col-12 col-md-6">
          <div class="d-flex flex-column flex-lg-row">
            <div class="escalation-label">Role:</div>
            <span
              class="font-weight-semibold"
              :class="{ 'font-color-primary': isActiveLevel }"
            >
              {{ escalation.role }}</span
            >
          </div>
          <div class="d-flex flex-column flex-lg-row mt-1">
            <div class="escalation-label">Escalation Time:</div>
            <span
              class="font-weight-semibold"
              :class="{ 'font-color-primary': isActiveLevel }"
              >{{ convertMinutesToDays }}</span
            >
          </div>
        </div>
        <div class="col-12 col-md-6 mt-1 mt-md-0">
          <div class="d-flex flex-column flex-lg-row">
            <div class="escalation-label">Contact Name:</div>
            <span
              class="font-weight-semibold"
              :class="{ 'font-color-primary': isActiveLevel }"
              >{{ escalation.name }}</span
            >
          </div>
          <div class="d-flex flex-column flex-lg-row mt-1">
            <div class="escalation-label">Contact:</div>
            <span
              class="font-weight-semibold"
              :class="{ 'font-color-primary': isActiveLevel }"
              >{{ escalation.contactEmail }} /
              {{ escalation.contactPhone }}</span
            >
          </div>
        </div>
      </div>

      <!-- NOTIFICATION -->
      <div v-if="isShowNotification">
        <div class="d-flex mt-1">
          <div class="escalation-label mr-1 mr-md-0">Notifications:</div>
          <div
            class="font-weight-semibold mr-1"
            :class="
              escalation.enableSystemNotification
                ? 'text-color-primary'
                : 'text-color-grey'
            "
          >
            <feather-icon icon="BellIcon" />
          </div>
          <div
            class="font-weight-semibold mr-1"
            :class="
              escalation.enableEmailNotification
                ? 'text-color-primary'
                : 'text-color-grey'
            "
          >
            <feather-icon icon="MailIcon" />
          </div>
          <div
            class="font-weight-semibold mr-2"
            :class="
              escalation.enableLineNotification
                ? 'text-color-primary'
                : 'text-color-grey'
            "
          >
            <feather-icon icon="MessageCircleIcon" />
          </div>
          <div class="text-underline" @click="clickToggleShowNotification">
            {{ isShowNotiInfo ? "Hide" : "Detail" }}
          </div>
        </div>
      </div>

      <Transition name="smooth">
        <div v-show="isShowNotiInfo" class="col-11">
          <div class="d-flex align-items-center flex-lg-row mt-1">
            <b-avatar
              rounded
              size="32"
              :variant="
                escalation.enableSystemNotification
                  ? 'light-primary'
                  : 'light-secondary'
              "
              :disabled="!escalation.enableSystemNotification"
            >
              <feather-icon icon="BellIcon" />
            </b-avatar>

            <div
              class="pl-1"
              :class="
                escalation.enableSystemNotification
                  ? 'text-color-primary text-weight-medium'
                  : 'text-color-grey'
              "
            >
              System Notification
            </div>
          </div>

          <div class="d-flex align-items-center flex-lg-row mt-1">
            <b-avatar
              rounded
              size="32"
              :variant="
                escalation.enableEmailNotification
                  ? 'light-primary'
                  : 'light-secondary'
              "
              :disabled="!escalation.enableEmailNotification"
            >
              <feather-icon icon="MailIcon" />
            </b-avatar>

            <div
              class="pl-1"
              :class="
                escalation.enableEmailNotification
                  ? 'text-color-primary text-weight-medium'
                  : 'text-color-grey'
              "
            >
              {{ escalation.email || "-" }}
            </div>
          </div>

          <div class="d-flex align-items-center flex-lg-row mt-1">
            <b-avatar
              rounded
              size="32"
              :variant="
                escalation.enableLineNotification
                  ? 'light-primary'
                  : 'light-secondary'
              "
              :disabled="!escalation.enableLineNotification"
            >
              <feather-icon icon="MessageCircleIcon" />
            </b-avatar>

            <div
              class="pl-1"
              :class="
                escalation.enableLineNotification
                  ? 'text-color-primary text-weight-medium'
                  : 'text-color-grey'
              "
            >
              {{ escalation.lineTokenAlias || "-" }}
            </div>
          </div>
        </div>
      </Transition>
      <!-- NOTIFICATION -->
    </div>

    <div
      v-if="
        !isShowInfo &&
        (escalation.isEscalated || escalation.showEscalationButton)
      "
      class="col-12 col-md-2 mt-1 mt-md-0"
    >
      <div
        v-if="escalation.isEscalated && !escalation.showEscalationButton"
        class="d-flex justify-content-center"
      >
        <div class="d-flex flex-column text-center">
          <b-badge pill variant="light-secondary" class="font-12px">
            Escalated
          </b-badge>
          <span class="text-size-10 escalation-badge">{{
            escalation.escalatedByUser.fullName || "-"
          }}</span>
          <span class="text-size-10 escalation-time">{{ escalationDate }}</span>
        </div>
      </div>

      <div
        v-if="escalation.showEscalationButton && hasUpdatePermission"
        class="d-md-flex justify-content-md-center flex-column"
      >
        <atom-button
          button-id="button__create"
          class="escalation-button"
          :is-disable="!!escalation.canEscalateAt"
          @click="$emit('onClickEscalateLevel')"
          >Escalate</atom-button
        >
        <div v-if="escalation.canEscalateAt">
          <div class="d-flex flex-column text-center">
            <span class="text-size-10 escalation-badge">
              Time until Escalatable
            </span>
            <span class="text-size-10 escalation-time">{{
              canEscalationDate
            }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { BBadge, BAvatar } from "bootstrap-vue"
import AtomButton from "@/components/atoms/AtomButton.vue"
import { DateTime } from "luxon"

export default {
  name: "MoleculeEscalationItem",
  components: { BBadge, AtomButton, BAvatar },
  emits: ["onClickEscalateLevel"],
  props: {
    escalation: {
      type: Object,
      required: true,
    },
    isShowInfo: {
      type: Boolean,
      required: true,
    },
    hasUpdatePermission: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  data() {
    return {
      isShowNotiInfo: false,
    }
  },
  computed: {
    isActiveLevel() {
      return this.escalation.isCurrentLevel && !this.isShowInfo
    },

    isShowNotification() {
      return this.escalation?.isShowNotificationDetail || false
    },

    canEscalationDate() {
      return this.escalation.canEscalateAt
        ? DateTime.fromISO(this.escalation.canEscalateAt).toFormat(
            "dd/MM/yyyy HH:mm:ss"
          )
        : "-"
    },

    escalationDate() {
      return this.escalation.escalatedAt
        ? DateTime.fromISO(this.escalation.escalatedAt).toFormat(
            "dd/MM/yyyy HH:mm:ss"
          )
        : "-"
    },

    convertMinutesToDays() {
      if (!this.escalation.escalationTimeMinute) return "-"

      const mins = this.escalation.escalationTimeMinute % 60
      const hour = Math.floor(this.escalation.escalationTimeMinute / 60)
      const days = Math.floor(hour / 24)
      const hours = hour % 24

      return `${days ? `${days} Day` : ""} ${hours ? `${hours} Hours` : ""} ${
        mins ? `${mins} Mins` : ""
      }`
    },
  },
  methods: {
    variantAlert(isEnable) {
      return isEnable ? "light-success" : "light-secondary"
    },
    textAlert(isEnable) {
      return isEnable ? "Enabled" : "Disabled"
    },
    clickToggleShowNotification() {
      this.isShowNotiInfo = !this.isShowNotiInfo
    },
  },
}
</script>

<style lang="scss" scoped>
.smooth-enter-active,
.smooth-leave-active {
  transition: opacity 0.5s;
}
.smooth-enter,
.smooth-leave-to {
  opacity: 0;
}

.escalation-label {
  width: 130px;
}

.escalation-badge {
  margin-top: 10px;
}

.escalation-time {
  margin-top: 4px;
}

.text-underline {
  text-decoration: underline;
}
</style>
